import LySearchDialog from './src/index.vue'

LySearchDialog.install = function (Vue) {
    Vue.component(LySearchDialog.name, LySearchDialog)
}

export default LySearchDialog


//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/search-dialog/index.js
// module id = null
// module chunks = 